// FileManager section routes; sections are identified by pathname only.
export enum FileManagerRoutes {
  ALL_FILES = '/files/all-files',
  RECENTS = '/files/recents',
  TRASH = '/files/trash',
}
